import React from 'react';
import { ArrowLeft, ChevronRight, Coins } from 'lucide-react';
import { EmptyState } from './EmptyState';
interface Area {
  id: string;
  name: string;
  cost: string;
  siteCount: number;
}
interface OvertimeCostAreaListProps {
  provinceName: string;
  provinceId: string;
  onBack: () => void;
  onAreaClick?: (areaId: string) => void;
}
// Mock data for areas
const areasByProvince: Record<string, Area[]> = {
  wc: [{
    id: 'ct-cbd',
    name: 'Cape Town CBD',
    cost: 'R180,000',
    siteCount: 2
  }, {
    id: 'north',
    name: 'Northern Suburbs',
    cost: 'R85,000',
    siteCount: 2
  }, {
    id: 'south',
    name: 'Southern Suburbs',
    cost: 'R55,000',
    siteCount: 1
  }],
  kzn: [{
    id: 'dbn-central',
    name: 'Durban Central',
    cost: 'R165,000',
    siteCount: 2
  }, {
    id: 'umhlanga',
    name: 'Umhlanga',
    cost: 'R120,000',
    siteCount: 2
  }],
  gp: [{
    id: 'sandton',
    name: 'Sandton',
    cost: 'R142,500',
    siteCount: 2
  }, {
    id: 'midrand',
    name: 'Midrand',
    cost: 'R100,000',
    siteCount: 1
  }]
};
export function OvertimeCostAreaList({
  provinceName,
  provinceId,
  onBack,
  onAreaClick
}: OvertimeCostAreaListProps) {
  const areas = areasByProvince[provinceId] || [];
  return <div className="flex flex-col space-y-6 animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-826">
      {/* Header Section */}
      <div className="flex flex-col space-y-2" data-id="element-827">
        <button onClick={onBack} className="group flex w-fit items-center text-sm font-medium text-[#5a7280] hover:text-[#062133] transition-colors min-h-[44px] px-2 -ml-2 rounded-lg hover:bg-[#062133]/5" aria-label="Back to province list" data-id="element-828">
          <ArrowLeft className="mr-1 h-4 w-4 transition-transform group-hover:-translate-x-1" data-id="element-829" />
          Back to Provinces
        </button>

        <div className="flex items-center justify-between" data-id="element-830">
          <div data-id="element-831">
            <h2 className="text-2xl font-bold text-[#062133]" data-id="element-832">
              {provinceName} Areas
            </h2>
            <p className="text-[#5a7280]" data-id="element-833">
              Select an area to view site details
            </p>
          </div>
        </div>
      </div>

      {/* Area List Card */}
      <div className="overflow-hidden rounded-xl border border-[#e5e5e5] bg-white shadow-sm" data-id="element-834">
        <div className="divide-y divide-[#e5e5e5]" data-id="element-835">
          {areas.length > 0 ? areas.map(area => <button key={area.id} onClick={() => onAreaClick?.(area.id)} className="group flex w-full items-center justify-between p-5 text-left transition-all hover:bg-[#fafaf9] focus:outline-none focus:bg-[#fafaf9] min-h-[72px]" data-id="element-836">
                <div className="flex items-center gap-4" data-id="element-837">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-rose-500/10 text-rose-600" data-id="element-838">
                    <Coins className="h-5 w-5" data-id="element-839" />
                  </div>
                  <div data-id="element-840">
                    <span className="block text-lg font-semibold text-[#062133]" data-id="element-841">
                      {area.name}
                    </span>
                    <div className="flex items-center gap-2 text-sm text-[#5a7280]" data-id="element-842">
                      <span className="font-medium text-rose-600" data-id="element-843">
                        {area.cost}
                      </span>
                      <span data-id="element-844">•</span>
                      <span data-id="element-845">
                        {area.siteCount}{' '}
                        {area.siteCount === 1 ? 'site' : 'sites'}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-4" data-id="element-846">
                  <ChevronRight className="h-5 w-5 text-[#e5e5e5] transition-colors group-hover:text-[#062133]" data-id="element-847" />
                </div>
              </button>) : <div className="p-0 border-none" data-id="element-848">
              <EmptyState icon={Coins} title="No overtime costs" description="All sites in this province are within budget" data-id="element-849" />
            </div>}
        </div>
      </div>
    </div>;
}